export const fullImage = (path: string) => path.replace(/(\.[^.]+)$/, `-full$1`);
export const thumbnail = (path: string) => path.replace(/(\.[^.]+)$/, `-thumbnail$1`);
export const blurred = (path: string) => path.replace(/(\.[^.]+)$/, `-blurred$1`);
export const imgUrl = (tripId: string, basename: string) => {
  return `https://media.${process.env.REACT_APP_HOST}/${tripId}/${basename.replace(/^\//, '')}`;
};
